export default "__VITE_ASSET__C_iPyxIB__"